import { PassengerSlot, PassengerSlotKind } from '../types';

export const passengerSlotKindMeta: Record<
	PassengerSlotKind,
	{ chipLabel: string; chipColor: 'default' | 'primary' | 'warning' | 'info' }
> = {
	adult: { chipLabel: 'Adulto', chipColor: 'primary' },
	child: { chipLabel: 'Menor', chipColor: 'warning' },
	infant: { chipLabel: 'Infante', chipColor: 'info' },
};

export const getSlotLabelById = (slots: PassengerSlot[], slotId: string): string | undefined =>
	slots.find((s) => s.id === slotId)?.label;

export const getBirthdateAgeMismatchHint = (
	birthdate: string | undefined,
	slot: PassengerSlot | undefined,
): string | null => {
	if (!slot?.childAge || !birthdate || slot.kind === 'adult') {
		return null;
	}
	const birth = new Date(birthdate);
	if (Number.isNaN(birth.getTime())) {
		return null;
	}
	const today = new Date();
	let age = today.getFullYear() - birth.getFullYear();
	const monthDiff = today.getMonth() - birth.getMonth();
	if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
		age -= 1;
	}
	const tolerance = 2;
	if (Math.abs(age - slot.childAge) > tolerance) {
		return `En la cotización este pasajero figura como ${slot.childAge} años. Revisá la fecha de nacimiento.`;
	}
	return null;
};
